.header {
  background-color: var(--bs-gray-100);
  border-bottom: 1px solid #e0e0e0;
  padding: unset;
  width: 100%;
}

.inner {
  max-width: 1536px;
  margin: 0 auto;
  width: 100%;
  padding: 0.5rem 0.5rem;
  @media (min-width: 768px) {
    padding: 0.5rem 1rem;
  }
}

.desktopRow {
  display: none;
}

.mobileStack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mobileTopRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .mobileActions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
} */

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: #2a8fe6;
  font-weight: 700;
}

.brandIcon {
  width: 36px;
  height: 36px;
}

.brandText {
  font-size: 1.15rem;
}

.desktopNav {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.desktopNavLink {
  color: #111827;
  text-decoration: none;
  font-weight: 600;
}

.desktopNavLink:hover {
  text-decoration: underline;
}

.helpMenu {
  position: relative;
}

.helpMenuTrigger {
  border: 0;
  background: transparent;
  color: #111827;
  font-weight: 600;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
}

.helpMenuPanel {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 18rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  z-index: 30;
  padding: 0.5rem;
}

.helpMenu:hover .helpMenuPanel,
.helpMenu:focus-within .helpMenuPanel {
  display: block;
}

.helpItem {
  display: block;
  text-decoration: none;
  color: inherit;
  padding: 0.5rem;
  border-radius: 0.5rem;
}

.helpItem:hover {
  background: #f3f4f6;
}

.helpTitle {
  font-weight: 600;
  color: #111827;
}

.helpDescription {
  margin: 0.15rem 0 0;
  color: #4b5563;
  font-size: 0.85rem;
}

.searchForm {
  flex: 1;
  min-width: 10rem;
  position: relative;
}

.searchInput {
  width: 100%;
  height: 38px;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  padding: 0 1rem 0 2.25rem;
  outline: none;
}

.searchInput:focus {
  border-color: #2a8fe6;
}

.searchInputError {
  border-color: #dc3545;
}

.searchIcon {
  position: absolute;
  left: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

.institutionButton {
  border: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.institutionLogo {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  object-fit: cover;
  background: #f3f4f6;
}

.institutionName {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 12rem;
}

.linkGroup {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.loginLink {
  color: #111827;
  text-decoration: none;
  font-weight: 600;
}

.registerLink {
  color: #111827;
  text-decoration: none;
  font-weight: 600;
  border: 1px solid #111827;
  border-radius: 9999px;
  padding: 0.25rem 0.8rem;
}

.banner {
  max-width: 1536px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem 0.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  color: #111827;
}

.bannerLink {
  font-weight: 600;
  color: #111827;
}

.taskLabel {
  font-weight: 700;
  text-decoration: underline;
}

.taskDot {
  color: #fd7e14;
  font-size: 1.4rem;
  line-height: 0.8rem;
}

@media (min-width: 768px) {
  .desktopRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .mobileStack {
    display: none;
  }
}
